export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '日期',
		align: 'center',
		dataIndex: 'taskTime',
		scopedSlots: { customRender: 'taskTime' },
	},
	{
		title: '订单号',
		align: 'center',
		dataIndex: 'orderNo',
	},
	{
		title: '服务公司',
		align: 'center',
		dataIndex: 'partnerName',
	},
	{
		title: '作业人员',
		align: 'center',
		dataIndex: 'visitorName',
	},
	{
		title: '伤者姓名',
		align: 'center',
		dataIndex: 'injuryName',
	},
	{
		title: '伤者电话',
		align: 'center',
		dataIndex: 'phones',
	},
	{
		title: '回访任务类型',
		align: 'center',
		dataIndex: 'revisitType',
		scopedSlots: { customRender: 'revisitType' },
	},
	{
		title: '任务状态',
		align: 'center',
		dataIndex: 'taskStatus',
		scopedSlots: { customRender: 'taskStatus' },
	},
	{
		title: '回访状态',
		align: 'center',
		dataIndex: 'revisitStatus',
		scopedSlots: { customRender: 'revisitStatus' },
	},
	{
		title: '是否异常',
		align: 'center',
		dataIndex: 'exception',
	},
	// 	{
	// 	title: '态度问题',
	// 	align: 'center',
	// 	dataIndex: 'attitude',
	// 	scopedSlots: { customRender: 'attitude' },
	// },
	// {
	// 	title: '指导理赔',
	// 	align: 'center',
	// 	dataIndex: 'guide',
	// 	scopedSlots: { customRender: 'guide' },
	// },
	// {
	// 	title: '推荐律师',
	// 	align: 'center',
	// 	dataIndex: 'recommend',
	// 	scopedSlots: { customRender: 'recommend' },
	// },
	{
		title: '回访时间',
		align: 'center',
		dataIndex: 'revisitTime',
		scopedSlots: { customRender: 'revisitTime' },
	},
	{
		title: '回访人',
		align: 'center',
		dataIndex: 'revisitorName',
	},
	{
		title: '操作',
		align: 'center',
		dataIndex: 'revisitType',
		key: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
